import React, { useState } from "react";
import styled from "styled-components";
import { TitleSection, Inner } from "../../components/commonWidgets";
import theme from "../../theme";
import AnimateOnScroll from "../../components/AnimateOnScroll";
import HighlightTitle from "../../components/HighlightTitle";

const Section = styled.section`
  /*background-color: #ffffff;*/
  width: 100%;
  padding: 2rem 0;
`;

const Container = styled(Inner)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  max-width: 800px;
  text-align: center;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: var(--my-color3);
  margin-top: 1rem;
  max-width: 600px;
`;

const FAQContainer = styled.div`
  width: 100%;
  margin-top: 2rem;
`;

const FAQItem = styled.div`
  border: 1px solid var(--my-color3);
  border-radius: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const QuestionButton = styled.button`
  width: 100%;
  padding: 1.5rem;
  background-color: #ffffff;
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
  color: var(--my-color3);
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--my-color3);
    color: white;
  }

  &.active {
    background-color: var(--my-color3);
    color: white;
  }
`;

const Answer = styled.div`
  padding: 0 1.5rem;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
  color: var(--my-color3);
  line-height: 1.5rem;

  &.active {
    padding: 1.5rem;
    max-height: 200px;
  }
`;

const Icon = styled.span`
  font-size: 1.2rem;
  transition: transform 0.3s ease;

  &.active {
    transform: rotate(45deg);
  }
`;

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Combien de temps pour voir des résultats ?",
      answer:
        "48 h pour l’audit complet, 7 jours pour une landing page optimisée, 3 semaines pour un site sur-mesure. Vous verrez généralement un impact sur vos conversions dès la mise en ligne.",
    },
    {
      question: "Quel budget minimum faut-il prévoir ?",
      answer:
        "Nous proposons des packs dès 2 000 € pour une landing page performante. Pour un site complet, les budgets débutent à 4 500 €. Nous adaptons toujours la phase 1 au retour sur investissement attendu.",
    },
    {
      question: "Puis-je gérer le contenu moi-même après livraison ?",
      answer:
        "Oui. Nous livrons une interface d’administration intuitive qui vous permet d’ajouter ou modifier facilement pages, images et articles sans toucher au code.",
    },
    {
      question: "Vous travaillez 100 % à distance ?",
      answer:
        "Tout à fait. Les ateliers stratégiques se déroulent par téléphone ou visio. Nous collaborons déjà avec des entreprises basées en France, Suisse, Canada et DOM-TOM.",
    },
    {
      question: "Quel accompagnement après la mise en ligne ?",
      answer:
        "Nous incluons 3 mois de suivi : correctifs, micro-ajustements UX et monitoring des performances (SEO & Core Web Vitals). Au-delà, un forfait évolutif ou à la carte est possible.",
    },
    {
      question: "Où sont hébergés vos serveurs ?",
      answer:
        "Nos infrastructures sont situées en France, dans des datacenters certifiés et conformes RGPD, garantissant performance, sécurité et faible latence pour vos visiteurs européens.",
    },
    {
      question: "Quelles technologies utilisez-vous ?",
      answer:
        "Nous misons sur des technologies web modernes et performantes, régulièrement mises à jour, pour assurer rapidité de chargement, évolutivité et pérennité de votre projet.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <Section>
      <Container>
        <HighlightTitle
          text="Questions fréquentes"
          highlightWord="Questions"
          bg="var(--my-color3)"
          rotateText={false}
          mainTextColor="var(--my-color3)"
          textColor="white"
        />
        <Subtitle>
          Les réponses aux questions que vous vous posez sur notre approche et
          nos garanties.
        </Subtitle>
        <FAQContainer>
          {faqs.map((faq, index) => (
            <AnimateOnScroll key={index} type="fade">
              <FAQItem>
                <QuestionButton
                  className={activeIndex === index ? "active" : ""}
                  onClick={() => toggleFAQ(index)}
                >
                  {faq.question}
                  <Icon className={activeIndex === index ? "active" : ""}>
                    {activeIndex === index ? "−" : "+"}
                  </Icon>
                </QuestionButton>
                <Answer className={activeIndex === index ? "active" : ""}>
                  {faq.answer}
                </Answer>
              </FAQItem>
            </AnimateOnScroll>
          ))}
        </FAQContainer>
      </Container>
    </Section>
  );
};

export default FAQSection;
